import { SliderHero } from './SliderHero';
import { Slide } from './Slide';

export type TypeSliderHero = typeof SliderHero & {
  Slide: typeof Slide;
};

(SliderHero as TypeSliderHero).Slide = Slide;
Slide.displayName = 'SlideHero.Slide';

export type { TypeSliderHeroProps, TypeSlideProps } from './types';
export default SliderHero as TypeSliderHero;
